const docCsvIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22">
      <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
        <g class="color-stroke" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6.88333333 14.3825C6.9175 14.9591667 7.36666667 15.4166667 7.91666667 15.4166667 8.48833333 15.4166667 8.95 14.9216667 8.95 14.3116667 8.95 13.4116667 8.09666667 13.385 7.91583333 13.3333333 7.735 13.28 6.88166667 13.2533333 6.88166667 12.3541667 6.88166667 11.745 7.34583333 11.25 7.91666667 11.25 8.465 11.25 8.91416667 11.7075 8.94833333 12.2833333M5.1725 12.2825C5.03916667 11.6625 4.73833333 11.2491667 4.09166667 11.2491667 3.09083333 11.2491667 2.91666667 12.1125 2.91666667 13.3333333 2.91666667 14.5533333 3.09083333 15.4166667 4.09166667 15.4166667 4.7375 15.4166667 5.03916667 15.0033333 5.1725 14.3833333"/>
          <polyline points="10.833 11.25 12.083 15.417 13.333 11.25"/>
          <polygon points="16.25 19.583 .417 19.583 .417 .417 11.25 .417 16.25 5.417"/>
          <polyline points="11.25 .417 11.25 5.417 16.25 5.417"/>
        </g>
        <polygon points="0 0 17 0 17 20 0 20 0 9.23"/>
      </g>
    </svg>
    `;

export default docCsvIcon;
